/**
 * Bee Hive Partner Website V2 — Phase E shared cart engine.
 * One engine for all templates + generated page.
 * Shopify Ajax cart is authority. bee_hive_ref is cart-level attribution.
 */
(function (global) {
  'use strict';

  var ATTR = 'bee_hive_ref';
  var DEMO_REFS = {
    john: 1,
    fitclub: 1,
    lina: 1,
    mila: 1,
    mia: 1,
    'partners-john': 1,
    'store-fitclub': 1,
    'store-lina': 1,
    'preview-partner': 1,
    'editor-preview': 1,
    'dirk-test': 1,
  };

  var PARTNER_LABELS = {
    'beehive-01': { nl: 'Coach John', en: 'Coach John' },
    'beehive-02': { nl: 'Mia Moves', en: 'Mia Moves' },
    'beehive-03': { nl: 'FitClub', en: 'FitClub' },
    'beehive-04': { nl: 'Lina', en: 'Lina' },
  };

  var MSG = {
    nl: {
      demo: 'Dit is een voorbeeldpagina. Bee Hive-cart en attributie zijn hier niet actief.',
      otherPartner:
        'Deze cart hoort al bij een andere Bee Hive-partner. Rond die checkout af of leeg de cart voordat je een nieuwe start.',
      pointsReward:
        'Rond je MUSKLE Points-bestelling eerst apart af voordat je deze Bee Hive-checkout start.',
      attributionFail: 'Deze partner-checkout kon niet worden gestart. Probeer het opnieuw.',
      addFail: 'Product kon niet worden toegevoegd. Probeer het opnieuw.',
      soldOut: 'Dit product is uitverkocht.',
      notReady: 'Dit product is nu niet beschikbaar.',
      emptyCheckout: 'Je cart is leeg.',
      checkoutBlocked: 'Checkout is nu niet beschikbaar voor deze partner-cart.',
      added: 'Toegevoegd aan cart',
      ordinaryNote: 'Ook andere MUSKLE-producten in je cart',
      partnerCartBlocked:
        'Je winkelwagen hoort al bij een andere Bee Hive-partner. Rond die checkout af of leeg de cart voordat je hier toevoegt.',
      cartSwitchForeign:
        'Je hebt nog producten in je winkelwagen van {{other}}. Wil je een nieuwe winkelwagen voor {{current}} starten? Je huidige Bee Hive-winkelwagen wordt leeggemaakt.',
      cartSwitchOrdinary:
        'Je winkelwagen bevat al andere producten. Wil je een aparte Bee Hive-partnerwinkelwagen voor {{current}} starten? Je huidige winkelwagen wordt leeggemaakt.',
      cartSwitchKeep: 'Huidige winkelwagen behouden',
      cartSwitchNew: 'Nieuwe {{current}}-winkelwagen starten',
      cartSwitchNewGeneric: 'Nieuwe partnerwinkelwagen starten',
      remove: 'Verwijderen',
      subtotal: 'Subtotaal',
      emptyCart: 'Je winkelwagen is leeg.',
      viewProducts: 'Bekijk producten',
      itemOne: 'artikel',
      itemMany: 'artikelen',
    },
    en: {
      demo: 'This is a sample page. Bee Hive cart and attribution are not active here.',
      otherPartner:
        'This cart already belongs to another Bee Hive partner. Finish or empty that partner checkout before starting a new one.',
      pointsReward:
        'Finish your MUSKLE Points order separately before starting this Bee Hive checkout.',
      attributionFail: 'Could not start this partner checkout. Please try again.',
      addFail: 'Could not add the product. Please try again.',
      soldOut: 'This product is sold out.',
      notReady: 'This product is not available right now.',
      emptyCheckout: 'Your cart is empty.',
      checkoutBlocked: 'Checkout is not available for this partner cart right now.',
      added: 'Added to cart',
      ordinaryNote: 'Your cart also includes other MUSKLE products',
      partnerCartBlocked:
        'Your cart already belongs to another Bee Hive partner. Finish or empty that cart before adding here.',
      cartSwitchForeign:
        'You still have products in your cart from {{other}}. Start a new cart for {{current}}? Your current Bee Hive cart will be cleared.',
      cartSwitchOrdinary:
        'Your cart already contains other products. Start a separate Bee Hive partner cart for {{current}}? Your current cart will be cleared.',
      cartSwitchKeep: 'Keep current cart',
      cartSwitchNew: 'Start new {{current}} cart',
      cartSwitchNewGeneric: 'Start new partner cart',
      remove: 'Remove',
      subtotal: 'Subtotal',
      emptyCart: 'Your cart is empty.',
      viewProducts: 'View products',
      itemOne: 'item',
      itemMany: 'items',
    },
  };

  function trim(v) {
    return String(v == null ? '' : v).trim();
  }

  function normalizeRef(value) {
    return trim(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 64);
  }

  function isDemoRef(ref) {
    var n = normalizeRef(ref);
    return !n || Boolean(DEMO_REFS[n]);
  }

  function localeFrom(root) {
    var raw = trim(
      (root && root.getAttribute('data-bh-sf-locale')) ||
        (document.documentElement && document.documentElement.lang) ||
        ''
    ).toLowerCase();
    return raw.indexOf('en') === 0 ? 'en' : 'nl';
  }

  function t(root, key) {
    var pack = MSG[localeFrom(root)] || MSG.nl;
    return pack[key] || MSG.en[key] || key;
  }

  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'EUR' }).format(n / 100);
    } catch (e) {
      return '€' + (n / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getTrustedPartnerRef(root) {
    // Never trust ?partner_ref= / ?ref= for attribution.
    var fromAttr = normalizeRef(root.getAttribute('data-bh-sf-partner-ref'));
    if (fromAttr && !isDemoRef(fromAttr)) return fromAttr;
    return '';
  }

  function isAttributable(root) {
    if (isSampleCart(root)) return false;
    if (String(root.getAttribute('data-bh-sf-attributable') || '') !== 'true') return false;
    return Boolean(getTrustedPartnerRef(root));
  }

  function isSampleCart(root) {
    return String(root.getAttribute('data-bh-sf-sample-cart') || '') === 'true';
  }

  function hasMeaningfulPartnerRef(cart) {
    var ref = cartRef(cart);
    return Boolean(ref && !isDemoRef(ref));
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('cart_read_failed');
    return res.json();
  }

  async function updateCartAttributes(attrs) {
    var res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    });
    if (!res.ok) throw new Error('cart_attr_failed');
    return res.json();
  }

  async function addVariant(variantId, quantity) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity }],
      }),
    });
    var body = null;
    try {
      body = await res.json();
    } catch (e) {
      body = null;
    }
    if (!res.ok) {
      var err = new Error((body && (body.description || body.message)) || 'cart_add_failed');
      err.payload = body;
      throw err;
    }
    return body;
  }

  async function changeLine(key, quantity) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    if (!res.ok) throw new Error('cart_change_failed');
    return res.json();
  }

  function cartRef(cart) {
    var attrs = (cart && cart.attributes) || {};
    return normalizeRef(attrs[ATTR] || attrs.bee_hive_ref || '');
  }

  function partnerLabels(root) {
    if (root._bhPartnerLabels) return root._bhPartnerLabels;
    var labels = Object.assign({}, PARTNER_LABELS);
    var raw = trim(root.getAttribute('data-bh-sf-partner-labels'));
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        Object.keys(parsed || {}).forEach(function (key) {
          labels[normalizeRef(key)] = parsed[key];
        });
      } catch (e) {
        /* ignore malformed JSON */
      }
    }
    var current = normalizeRef(root.getAttribute('data-bh-sf-partner-ref'));
    var currentName = trim(root.getAttribute('data-bh-sf-partner-display-name'));
    if (current && currentName) {
      var loc = localeFrom(root);
      labels[current] = labels[current] || {};
      labels[current][loc] = currentName;
      labels[current].nl = labels[current].nl || currentName;
      labels[current].en = labels[current].en || currentName;
    }
    root._bhPartnerLabels = labels;
    return labels;
  }

  function partnerDisplayName(root, ref) {
    var key = normalizeRef(ref);
    if (!key) return '';
    var labels = partnerLabels(root);
    var pack = labels[key] || {};
    var loc = localeFrom(root);
    return pack[loc] || pack.en || pack.nl || key;
  }

  function cartPageScope(root) {
    return (
      root.closest('.muskle-bh-coach-page, .muskle-bh-influencer-page, .bh-page, [data-bh-partner-page]') ||
      root
    );
  }

  function classifyCartOwnership(root, cart) {
    var partner = getTrustedPartnerRef(root);
    var ref = cartRef(cart);
    var items = (cart && cart.items) || [];
    var hasItems = items.length > 0;
    if (!hasItems) return { kind: 'empty', ref: ref, partner: partner };
    if (!ref) return { kind: 'ordinary', ref: '', partner: partner };
    if (partner && ref === partner) return { kind: 'owned', ref: ref, partner: partner };
    if (ref && partner && ref !== partner) return { kind: 'foreign_partner', ref: ref, partner: partner };
    return { kind: 'other', ref: ref, partner: partner };
  }

  function scopeCartForDisplay(root, cart) {
    var ownership = classifyCartOwnership(root, cart);
    if (ownership.kind === 'owned' || ownership.kind === 'empty') {
      return {
        ownership: ownership,
        cart: cart,
        count: itemCount(cart),
        total_cents: cart && cart.total_price != null ? cart.total_price : 0,
      };
    }
    return {
      ownership: ownership,
      cart: {
        items: [],
        item_count: 0,
        total_price: 0,
        attributes: (cart && cart.attributes) || {},
      },
      count: 0,
      total_cents: 0,
    };
  }

  function interpolate(template, vars) {
    return String(template || '').replace(/\{\{(\w+)\}\}/g, function (_m, key) {
      return vars[key] != null ? String(vars[key]) : '';
    });
  }

  function cartSwitchMessage(root, ownership) {
    var current = partnerDisplayName(root, ownership.partner);
    var vars = { current: current, other: partnerDisplayName(root, ownership.ref) };
    if (ownership.kind === 'foreign_partner') return interpolate(t(root, 'cartSwitchForeign'), vars);
    if (ownership.kind === 'ordinary') return interpolate(t(root, 'cartSwitchOrdinary'), vars);
    return '';
  }

  function ensureSwitchModal(root) {
    var existing = root.querySelector('[data-bh-sf-cart-switch]');
    if (existing) return existing;
    var wrap = document.createElement('div');
    wrap.className = 'bh-sf-cart-switch';
    wrap.setAttribute('data-bh-sf-cart-switch', '');
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="bh-sf-cart-switch__backdrop" data-bh-sf-cart-switch-backdrop></div>' +
      '<div class="bh-sf-cart-switch__dialog" role="dialog" aria-modal="true" aria-labelledby="bh-sf-cart-switch-title">' +
      '<p class="bh-sf-cart-switch__message" id="bh-sf-cart-switch-title" data-bh-sf-cart-switch-msg></p>' +
      '<div class="bh-sf-cart-switch__actions">' +
      '<button type="button" class="bh-sf-btn bh-sf-btn--secondary" data-bh-sf-cart-switch-keep></button>' +
      '<button type="button" class="bh-sf-btn bh-sf-btn--primary" data-bh-sf-cart-switch-new></button>' +
      '</div></div>';
    root.appendChild(wrap);
    return wrap;
  }

  function showCartSwitchDialog(root, ownership) {
    return new Promise(function (resolve) {
      var modal = ensureSwitchModal(root);
      var msg = modal.querySelector('[data-bh-sf-cart-switch-msg]');
      var keepBtn = modal.querySelector('[data-bh-sf-cart-switch-keep]');
      var newBtn = modal.querySelector('[data-bh-sf-cart-switch-new]');
      var current = partnerDisplayName(root, ownership.partner);
      if (msg) msg.textContent = cartSwitchMessage(root, ownership);
      if (keepBtn) keepBtn.textContent = t(root, 'cartSwitchKeep');
      if (newBtn) {
        newBtn.textContent = interpolate(t(root, 'cartSwitchNew'), { current: current }) || t(root, 'cartSwitchNewGeneric');
      }
      function close(result) {
        modal.hidden = true;
        modal.setAttribute('hidden', '');
        keepBtn.removeEventListener('click', onKeep);
        newBtn.removeEventListener('click', onNew);
        modal.querySelector('[data-bh-sf-cart-switch-backdrop]').removeEventListener('click', onKeep);
        resolve(result);
      }
      function onKeep() {
        close(false);
      }
      function onNew() {
        close(true);
      }
      keepBtn.addEventListener('click', onKeep);
      newBtn.addEventListener('click', onNew);
      modal.querySelector('[data-bh-sf-cart-switch-backdrop]').addEventListener('click', onKeep);
      modal.hidden = false;
      modal.removeAttribute('hidden');
      if (newBtn.focus) newBtn.focus();
    });
  }

  async function clearCartCompletely() {
    var res = await fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('cart_clear_failed');
    return updateCartAttributes({ bee_hive_ref: '' });
  }

  async function resolveCartConflictBeforeAdd(root, cart) {
    var ownership = classifyCartOwnership(root, cart);
    if (ownership.kind === 'owned' || ownership.kind === 'empty') return { ok: true, cart: cart };
    if (cartHasPointsReward(cart)) {
      var err = new Error('points_reward');
      err.code = 'points_reward';
      throw err;
    }
    var confirmed = await showCartSwitchDialog(root, ownership);
    if (!confirmed) return { ok: false, reason: 'switch_cancelled' };
    await clearCartCompletely();
    var partner = getTrustedPartnerRef(root);
    var cleared = await fetchCart();
    if (((cleared && cleared.items) || []).length) throw new Error('cart_clear_verify_failed');
    if (partner) {
      cleared = await updateCartAttributes({ bee_hive_ref: partner });
      var verified = await fetchCart();
      if (cartRef(verified) !== partner) throw new Error('attr_verify_failed');
      cleared = verified;
    }
    return { ok: true, cart: cleared, switched: true };
  }

  function isPointsRewardItem(item) {
    var props = item && item.properties;
    if (!props) return false;
    if (Array.isArray(props)) {
      return props.some(function (p) {
        var name = String((p && p.name) || '').toLowerCase();
        var value = String((p && p.value) || '').toLowerCase();
        if (name === '_muskle_points_reward' && value === 'true') return true;
        if (name.indexOf('points') >= 0 && value === 'true' && name.indexOf('only') >= 0) return true;
        return false;
      });
    }
    if (typeof props === 'object') {
      if (String(props._muskle_points_reward || '').toLowerCase() === 'true') return true;
      if (String(props.points_only || '').toLowerCase() === 'true') return true;
    }
    return false;
  }

  function cartHasPointsReward(cart) {
    return ((cart && cart.items) || []).some(isPointsRewardItem);
  }

  function partnerVariantIdSet(root) {
    var map = root._bhSfMap || {};
    var set = Object.create(null);
    Object.keys(map).forEach(function (k) {
      var p = map[k];
      var vid = trim(p.selected_variant_id || p.variant_id);
      if (vid) set[vid] = true;
    });
    return set;
  }

  function cartHasPartnerVariant(cart, root) {
    var set = partnerVariantIdSet(root);
    return ((cart && cart.items) || []).some(function (item) {
      return set[String(item.variant_id || '')];
    });
  }

  function itemCount(cart) {
    return ((cart && cart.items) || []).reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);
  }

  function showStatus(root, message, kind) {
    var el = root.querySelector('[data-bh-sf-status]');
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || '';
    el.setAttribute('data-kind', kind || 'info');
    if (message) {
      el.setAttribute('role', 'status');
    }
  }

  function setBusy(root, busy) {
    root._bhSfBusy = Boolean(busy);
    root.querySelectorAll('[data-bh-sf-add], [data-bh-sf-checkout]').forEach(function (btn) {
      if (busy) {
        btn.setAttribute('data-bh-busy', '1');
        btn.disabled = true;
      } else if (btn.getAttribute('data-bh-busy') === '1') {
        btn.removeAttribute('data-bh-busy');
        // leave commerce_ready disabled state to drawer sync
        if (!btn.hasAttribute('data-bh-keep-disabled')) btn.disabled = false;
      }
    });
  }

  function uiCopy(root, key) {
    var attr = 'data-bh-sf-copy-' + key.replace(/([A-Z])/g, function (m) {
      return '-' + m.toLowerCase();
    });
    var fromDom = root && root.getAttribute(attr);
    if (fromDom) return fromDom;
    return t(root, key);
  }

  function itemCountLabel(root, count) {
    var n = Number(count) || 0;
    if (n === 1) return '1 ' + uiCopy(root, 'itemOne');
    return String(n) + ' ' + uiCopy(root, 'itemMany');
  }

  function setCartBadge(root, count) {
    var scope = cartPageScope(root);
    var nodes = [];
    scope.querySelectorAll('[data-bh-sf-cart-count]').forEach(function (el) {
      nodes.push(el);
    });
    root.querySelectorAll('[data-bh-sf-cart-count]').forEach(function (el) {
      if (nodes.indexOf(el) < 0) nodes.push(el);
    });
    nodes.forEach(function (el) {
      el.textContent = String(count);
      if (count > 0) {
        el.hidden = false;
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
      } else {
        el.hidden = true;
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function renderMiniCart(root, cart) {
    var scoped = scopeCartForDisplay(root, cart);
    cart = scoped.cart;
    var list = root.querySelector('[data-bh-sf-minicart-lines]');
    var note = root.querySelector('[data-bh-sf-minicart-note]');
    var itemCountEl = root.querySelector('[data-bh-sf-minicart-item-count]');
    var subtotalRow = root.querySelector('[data-bh-sf-minicart-subtotal-row]');
    var footer = root.querySelector('[data-bh-sf-minicart] .bh-sf-minicart__footer');
    var partnerSet = partnerVariantIdSet(root);
    var items = (cart && cart.items) || [];
    var count = scoped.count;
    var total = money(scoped.total_cents);

    setCartBadge(root, count);
    root.querySelectorAll('[data-bh-sf-cart-total]').forEach(function (el) {
      el.textContent = total || '€0,00';
    });
    var sticky = root.querySelector('[data-bh-sf-sticky-cart]');
    if (sticky) sticky.hidden = count < 1;

    if (itemCountEl) {
      if (count > 0) {
        itemCountEl.textContent = itemCountLabel(root, count);
        itemCountEl.hidden = false;
        itemCountEl.removeAttribute('hidden');
      } else {
        itemCountEl.textContent = '';
        itemCountEl.hidden = true;
        itemCountEl.setAttribute('hidden', '');
      }
    }

    if (subtotalRow) {
      subtotalRow.hidden = count < 1;
      if (count > 0) subtotalRow.removeAttribute('hidden');
      else subtotalRow.setAttribute('hidden', '');
    }
    if (footer) footer.hidden = count < 1;

    if (list) {
      if (!items.length) {
        list.innerHTML =
          '<div class="bh-sf-minicart-empty">' +
          '<p class="bh-sf-minicart-empty__text">' +
          escapeHtml(uiCopy(root, 'emptyCart')) +
          '</p>' +
          '<a class="bh-sf-btn bh-sf-btn--secondary bh-sf-minicart-empty__cta" href="#bh-sf-products" data-bh-sf-minicart-continue>' +
          escapeHtml(uiCopy(root, 'viewProducts')) +
          '</a></div>';
      } else {
        list.innerHTML = items
          .map(function (item) {
            var vid = String(item.variant_id || '');
            var isPartner = Boolean(partnerSet[vid]);
            var img = item.image || (item.featured_image && item.featured_image.url) || '';
            var title = item.product_title || item.title || 'Product';
            var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
            var unitMoney = money(item.final_price != null ? item.final_price : item.price);
            var lineMoney = money(item.final_line_price != null ? item.final_line_price : item.line_price);
            var qty = Number(item.quantity) || 1;
            return (
              '<article class="bh-sf-minicart-line" data-bh-sf-line-key="' +
              escapeHtml(item.key) +
              '">' +
              (img
                ? '<img class="bh-sf-minicart-line__img" src="' +
                  escapeHtml(img) +
                  '" alt="" width="80" height="80" loading="lazy">'
                : '<div class="bh-sf-minicart-line__img bh-sf-minicart-line__img--placeholder" aria-hidden="true"></div>') +
              '<div class="bh-sf-minicart-line__body">' +
              '<div class="bh-sf-minicart-line__top">' +
              '<strong class="bh-sf-minicart-line__title">' +
              escapeHtml(title) +
              '</strong>' +
              '<span class="bh-sf-minicart-line__line-price">' +
              escapeHtml(lineMoney) +
              '</span></div>' +
              (variant ? '<p class="bh-sf-minicart-line__variant">' + escapeHtml(variant) + '</p>' : '') +
              (!isPartner
                ? '<p class="bh-sf-minicart-line__tag">' + escapeHtml(t(root, 'ordinaryNote')) + '</p>'
                : '') +
              '<div class="bh-sf-minicart-line__row">' +
              '<div class="bh-sf-qty-stepper bh-sf-qty-stepper--compact" role="group" aria-label="Aantal">' +
              '<button type="button" class="bh-sf-qty-stepper__btn" data-bh-sf-qty-dec data-line-key="' +
              escapeHtml(item.key) +
              '" aria-label="−">−</button>' +
              '<span class="bh-sf-qty-stepper__value">' +
              escapeHtml(String(qty)) +
              '</span>' +
              '<button type="button" class="bh-sf-qty-stepper__btn" data-bh-sf-qty-inc data-line-key="' +
              escapeHtml(item.key) +
              '" aria-label="+">+</button>' +
              '</div>' +
              '<button type="button" class="bh-sf-minicart-line__remove" data-bh-sf-remove data-line-key="' +
              escapeHtml(item.key) +
              '">' +
              escapeHtml(uiCopy(root, 'remove')) +
              '</button>' +
              '</div>' +
              (unitMoney && qty > 1
                ? '<p class="bh-sf-minicart-line__unit">' + escapeHtml(unitMoney) + ' / st</p>'
                : '') +
              '</div></article>'
            );
          })
          .join('');
      }
    }

    if (note) {
      var hasOrdinary = items.some(function (item) {
        return !partnerSet[String(item.variant_id || '')];
      });
      note.hidden = !hasOrdinary;
      note.textContent = hasOrdinary ? t(root, 'ordinaryNote') : '';
    }
  }

  async function syncAttributionCleanup(root, cart) {
    if (isSampleCart(root)) return cart;
    var ref = cartRef(cart);
    var partner = getTrustedPartnerRef(root);
    if (!ref) return cart;
    if (!((cart && cart.items) || []).length) {
      return updateCartAttributes({ bee_hive_ref: '' });
    }
    // If this page is attributable and owns the ref, clear when no partner variants remain.
    if (partner && ref === partner && !cartHasPartnerVariant(cart, root)) {
      return updateCartAttributes({ bee_hive_ref: '' });
    }
    return cart;
  }

  async function hydrate(root) {
    var cart = await fetchCart();
    cart = (await syncAttributionCleanup(root, cart)) || cart;
    if (cart && cart.attributes && !cart.items) {
      // update.js returns full cart; if only attributes echo, re-fetch
      cart = await fetchCart();
    }
    root._bhSfCart = cart;
    renderMiniCart(root, cart);

    if (isSampleCart(root)) {
      root._bhSfForeignPartner = hasMeaningfulPartnerRef(cart);
      if (root._bhSfForeignPartner) {
        showStatus(root, t(root, 'partnerCartBlocked'), 'warn');
        root.querySelectorAll('[data-bh-sf-add], [data-bh-sf-checkout]').forEach(function (btn) {
          btn.disabled = true;
          btn.setAttribute('data-bh-keep-disabled', '1');
        });
      } else {
        showStatus(root, '', 'info');
        root.querySelectorAll('[data-bh-keep-disabled]').forEach(function (btn) {
          btn.removeAttribute('data-bh-keep-disabled');
        });
      }
      return cart;
    }

    var partner = getTrustedPartnerRef(root);
    var ref = cartRef(cart);
    var ownership = classifyCartOwnership(root, cart);
    root._bhSfForeignPartner = ownership.kind === 'foreign_partner' || ownership.kind === 'ordinary';
    root._bhSfCartOwnership = ownership;
    if (ownership.kind === 'foreign_partner' || ownership.kind === 'ordinary') {
      showStatus(root, '', 'info');
    } else {
      showStatus(root, '', 'info');
    }
    root.querySelectorAll('[data-bh-keep-disabled]').forEach(function (btn) {
      btn.removeAttribute('data-bh-keep-disabled');
      btn.disabled = false;
    });
    return cart;
  }

  async function ensureAttribution(root, cart) {
    var partner = getTrustedPartnerRef(root);
    if (!partner) throw new Error('no_partner');
    var existing = cartRef(cart);
    if (existing && existing !== partner) {
      var err = new Error('other_partner');
      err.code = 'other_partner';
      throw err;
    }
    if (cartHasPointsReward(cart)) {
      var err2 = new Error('points_reward');
      err2.code = 'points_reward';
      throw err2;
    }
    if (existing === partner) return cart;
    var updated = await updateCartAttributes({ bee_hive_ref: partner });
    var verified = await fetchCart();
    if (cartRef(verified) !== partner) {
      var err3 = new Error('attr_verify_failed');
      err3.code = 'attr_verify_failed';
      throw err3;
    }
    return verified;
  }

  function validateProduct(product) {
    if (!product) return { ok: false, reason: 'notReady' };
    if (product.sold_out) return { ok: false, reason: 'soldOut' };
    if (product.commerce_ready === false) return { ok: false, reason: 'notReady' };
    if (product.available === false && product.commerce_ready !== true) return { ok: false, reason: 'soldOut' };
    var vid = trim(product.selected_variant_id || product.variant_id);
    if (!vid) return { ok: false, reason: 'notReady' };
    if (product.price_cents == null && product.commerce_ready !== true) return { ok: false, reason: 'notReady' };
    return { ok: true, variantId: vid };
  }

  function qtyFromDrawer(root, product) {
    var input = root.querySelector('[data-bh-sf-qty]');
    var min = Number(product && product.quantity_min);
    var step = Number(product && product.quantity_increment);
    if (!isFinite(min) || min < 1) min = 1;
    if (!isFinite(step) || step < 1) step = 1;
    var q = input ? Number(input.value) : min;
    if (!isFinite(q) || q < min) q = min;
    // snap to step grid from min
    q = min + Math.round((q - min) / step) * step;
    if (q < min) q = min;
    return q;
  }

  async function addSampleToCart(root, product, opts) {
    opts = opts || {};
    if (root._bhSfBusy) return { ok: false, reason: 'busy' };
    if (root._bhSfForeignPartner) {
      showStatus(root, t(root, 'partnerCartBlocked'), 'warn');
      return { ok: false, reason: 'partner_cart_active' };
    }
    var check = validateProduct(product);
    if (!check.ok) {
      showStatus(root, t(root, check.reason), 'error');
      return { ok: false, reason: check.reason };
    }

    setBusy(root, true);
    try {
      var cart = await fetchCart();
      if (hasMeaningfulPartnerRef(cart)) {
        root._bhSfForeignPartner = true;
        showStatus(root, t(root, 'partnerCartBlocked'), 'warn');
        return { ok: false, reason: 'partner_cart_active' };
      }
      if (cartHasPointsReward(cart)) {
        showStatus(root, t(root, 'pointsReward'), 'error');
        return { ok: false, reason: 'points_reward' };
      }
      var qty = opts.quantity != null ? Number(opts.quantity) : qtyFromDrawer(root, product);
      if (!isFinite(qty) || qty < 1) qty = 1;
      await addVariant(check.variantId, qty);
      cart = await fetchCart();
      root._bhSfCart = cart;
      renderMiniCart(root, cart);
      showStatus(root, t(root, 'added'), 'ok');
      if (opts.openCart !== false) {
        if (global.BeeHivePartnerStorefront && typeof global.BeeHivePartnerStorefront.openCart === 'function') {
          global.BeeHivePartnerStorefront.openCart(root);
        } else {
          var panel = root.querySelector('[data-bh-sf-minicart]');
          if (panel) {
            panel.hidden = false;
            panel.setAttribute('aria-hidden', 'false');
          }
        }
      }
      return { ok: true, cart: cart };
    } catch (e) {
      showStatus(root, t(root, 'addFail'), 'error');
      return { ok: false, reason: 'add_failed', error: e };
    } finally {
      setBusy(root, false);
    }
  }

  async function addToCart(root, product, opts) {
    opts = opts || {};
    if (root._bhSfBusy) return { ok: false, reason: 'busy' };
    if (isSampleCart(root)) {
      return addSampleToCart(root, product, opts);
    }
    if (!isAttributable(root)) {
      showStatus(root, t(root, 'demo'), 'warn');
      return { ok: false, reason: 'demo' };
    }
    var check = validateProduct(product);
    if (!check.ok) {
      showStatus(root, t(root, check.reason), 'error');
      return { ok: false, reason: check.reason };
    }

    setBusy(root, true);
    try {
      var cart = await fetchCart();
      var conflict = await resolveCartConflictBeforeAdd(root, cart);
      if (!conflict.ok) return { ok: false, reason: conflict.reason || 'switch_cancelled' };
      cart = conflict.cart || cart;
      cart = await ensureAttribution(root, cart);
      var qty = opts.quantity != null ? Number(opts.quantity) : qtyFromDrawer(root, product);
      if (!isFinite(qty) || qty < 1) qty = 1;
      await addVariant(check.variantId, qty);
      cart = await hydrate(root);
      showStatus(root, t(root, 'added'), 'ok');
      if (opts.openCart !== false) {
        if (global.BeeHivePartnerStorefront && typeof global.BeeHivePartnerStorefront.openCart === 'function') {
          global.BeeHivePartnerStorefront.openCart(root);
        } else {
          var panel = root.querySelector('[data-bh-sf-minicart]');
          if (panel) {
            panel.hidden = false;
            panel.setAttribute('aria-hidden', 'false');
          }
        }
      }
      return { ok: true, cart: cart };
    } catch (e) {
      var code = e && e.code;
      if (code === 'other_partner') showStatus(root, t(root, 'otherPartner'), 'error');
      else if (code === 'points_reward') showStatus(root, t(root, 'pointsReward'), 'error');
      else if (code === 'attr_verify_failed' || e.message === 'attr_verify_failed')
        showStatus(root, t(root, 'attributionFail'), 'error');
      else if (e.message === 'cart_clear_verify_failed') showStatus(root, t(root, 'addFail'), 'error');
      else showStatus(root, t(root, 'addFail'), 'error');
      return { ok: false, reason: code || e.message || 'add_failed', error: e };
    } finally {
      setBusy(root, false);
    }
  }

  async function checkoutSample(root) {
    setBusy(root, true);
    try {
      var cart = await fetchCart();
      if (hasMeaningfulPartnerRef(cart)) {
        root._bhSfForeignPartner = true;
        showStatus(root, t(root, 'partnerCartBlocked'), 'warn');
        return { ok: false, reason: 'partner_cart_active' };
      }
      if (!((cart.items || []).length)) {
        showStatus(root, t(root, 'emptyCheckout'), 'warn');
        return { ok: false, reason: 'empty' };
      }
      if (cartHasPointsReward(cart)) {
        showStatus(root, t(root, 'pointsReward'), 'error');
        return { ok: false, reason: 'points_reward' };
      }
      var verified = await fetchCart();
      if (cartRef(verified)) {
        showStatus(root, t(root, 'partnerCartBlocked'), 'warn');
        return { ok: false, reason: 'partner_ref_present' };
      }
      global.location.href = '/checkout';
      return { ok: true, redirected: true };
    } catch (e) {
      showStatus(root, t(root, 'checkoutBlocked'), 'error');
      return { ok: false, reason: 'error' };
    } finally {
      setBusy(root, false);
    }
  }

  async function checkout(root) {
    if (root._bhSfBusy) return { ok: false };
    if (isSampleCart(root)) {
      return checkoutSample(root);
    }
    if (!isAttributable(root)) {
      showStatus(root, t(root, 'demo'), 'warn');
      return { ok: false, reason: 'demo' };
    }
    setBusy(root, true);
    try {
      var cart = await fetchCart();
      var partner = getTrustedPartnerRef(root);
      var ownership = classifyCartOwnership(root, cart);
      if (ownership.kind !== 'owned') {
        showStatus(root, t(root, 'emptyCheckout'), 'warn');
        return { ok: false, reason: ownership.kind === 'empty' ? 'empty' : 'attr' };
      }
      if (!((cart.items || []).length)) {
        showStatus(root, t(root, 'emptyCheckout'), 'warn');
        return { ok: false, reason: 'empty' };
      }
      if (cartHasPointsReward(cart)) {
        showStatus(root, t(root, 'pointsReward'), 'error');
        return { ok: false, reason: 'points_reward' };
      }
      if (cartRef(cart) !== partner) {
        showStatus(root, t(root, 'attributionFail'), 'error');
        return { ok: false, reason: 'attr' };
      }
      if (!cartHasPartnerVariant(cart, root)) {
        showStatus(root, t(root, 'checkoutBlocked'), 'error');
        return { ok: false, reason: 'no_partner_items' };
      }
      // Final fail-closed verify
      var verified = await fetchCart();
      if (cartRef(verified) !== partner || !((verified.items || []).length)) {
        showStatus(root, t(root, 'attributionFail'), 'error');
        return { ok: false, reason: 'verify' };
      }
      global.location.href = '/checkout';
      return { ok: true, redirected: true };
    } catch (e) {
      showStatus(root, t(root, 'checkoutBlocked'), 'error');
      return { ok: false, reason: 'error' };
    } finally {
      setBusy(root, false);
    }
  }

  async function removeLine(root, key) {
    setBusy(root, true);
    try {
      await changeLine(key, 0);
      await hydrate(root);
    } finally {
      setBusy(root, false);
    }
  }

  async function bumpQty(root, key, delta) {
    var cart = root._bhSfCart || (await fetchCart());
    var item = ((cart && cart.items) || []).find(function (i) {
      return i.key === key;
    });
    if (!item) return;
    var next = Math.max(0, (Number(item.quantity) || 0) + delta);
    setBusy(root, true);
    try {
      await changeLine(key, next);
      await hydrate(root);
    } finally {
      setBusy(root, false);
    }
  }

  /**
   * Pure helpers for deterministic tests (no network).
   */
  function evaluateCartGates(partnerRef, cart, options) {
    options = options || {};
    var partner = normalizeRef(partnerRef);
    var attributable = options.attributable !== false && partner && !isDemoRef(partner);
    if (!attributable) return { allowed: false, reason: 'demo' };
    var existing = cartRef(cart || {});
    if (existing && existing !== partner) return { allowed: false, reason: 'other_partner' };
    if (cartHasPointsReward(cart || {})) return { allowed: false, reason: 'points_reward' };
    return { allowed: true, reason: existing === partner ? 'same_partner' : 'set_attr' };
  }

  function shouldClearRefAfterMutation(partnerRef, cart, partnerVariantIds) {
    var partner = normalizeRef(partnerRef);
    var existing = cartRef(cart || {});
    if (!existing) return false;
    if (!((cart && cart.items) || []).length) return true;
    if (existing !== partner) return false;
    var set = Object.create(null);
    (partnerVariantIds || []).forEach(function (id) {
      set[String(id)] = true;
    });
    var has = ((cart && cart.items) || []).some(function (item) {
      return set[String(item.variant_id || '')];
    });
    return !has;
  }

  global.BeeHivePartnerCart = {
    ATTR: ATTR,
    normalizeRef: normalizeRef,
    isDemoRef: isDemoRef,
    getTrustedPartnerRef: getTrustedPartnerRef,
    isAttributable: isAttributable,
    isSampleCart: isSampleCart,
    hasMeaningfulPartnerRef: hasMeaningfulPartnerRef,
    fetchCart: fetchCart,
    cartRef: cartRef,
    cartHasPointsReward: cartHasPointsReward,
    classifyCartOwnership: classifyCartOwnership,
    scopeCartForDisplay: scopeCartForDisplay,
    evaluateCartGates: evaluateCartGates,
    shouldClearRefAfterMutation: shouldClearRefAfterMutation,
    hydrate: hydrate,
    addToCart: addToCart,
    checkout: checkout,
    removeLine: removeLine,
    bumpQty: bumpQty,
    renderMiniCart: renderMiniCart,
    clearCartCompletely: clearCartCompletely,
    resolveCartConflictBeforeAdd: resolveCartConflictBeforeAdd,
    DEMO_REFS: DEMO_REFS,
    PARTNER_LABELS: PARTNER_LABELS,
  };
})(typeof window !== 'undefined' ? window : globalThis);
